import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    total: null,
    driverActiveTrip: {},
    userActiveTrip: {},
  },
  getters: {
    getTotalTrips(state) {
      return state.total
    },
    driverHasActiveTrip(state) {
      return !!Object.keys(state.driverActiveTrip).length
    },
    userHasActiveTrip(state) {
      return !!Object.keys(state.userActiveTrip).length
    },
  },
  mutations: {
    SET_TOTAL_TRIPS(state, val) {
      state.total = val
    },
    SET_DRIVER_ACTIVE_TRIP(state, data) {
      state.driverActiveTrip = data
    },
    SET_USER_ACTIVE_TRIP(state, data) {
      state.userActiveTrip = data
    },
  },
  actions: {
    async fetchDriverUserTripsList({ commit }, params) {
      commit('SET_TOTAL_TRIPS', null)
      const res = await axiosIns.get('/trips', {
        params,
      })
      const { total } = res.data.data
      commit('SET_TOTAL_TRIPS', total)
      return res
    },
    async fetchActiveTrips({ commit }, { id, userType }) {
      if (userType === 'driver') {
        commit('SET_DRIVER_ACTIVE_TRIP', {})
      } else {
        commit('SET_USER_ACTIVE_TRIP', {})
      }
      const res = (await axiosIns.get(`/trips/inflight/${userType}/${id}`)).data.data
      if (userType === 'driver') {
        commit('SET_DRIVER_ACTIVE_TRIP', res)
      } else {
        commit('SET_USER_ACTIVE_TRIP', res)
      }
      return res
    },

  },
}
